// extracted by mini-css-extract-plugin
module.exports = {"container":"Collection_container__YeKNF","appear":"Collection_appear__4hhie","gameTrigger":"Collection_gameTrigger__4sppM","selected":"Collection_selected__2Ejap"};